var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigblob1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1422.227,
    height: 1418.445,
    viewBox: "0 0 1422.227 1418.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.213,
    y1: 0.37,
    x2: 0.895,
    y2: 0.657,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f93"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blob-haikei",
    transform: "matrix(-0.695, -0.719, 0.719, -0.695, 577.642, 1075.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M628.758-63.246c23.77,77.15-29.537,184.594-31.555,321.728-21.9,189.391,47.7,303.589-61.283,444.6S141.693,938.961-49.365,865.871c-191.059-72.9-285.28-238.7-226.079-401.309S84.409,184.225,218.285,86.588c133.651-97.821,97.2-250.423,182.638-272.387,85.214-21.779,203.841,45.588,227.835,122.553",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigblob1);
export default __webpack_public_path__ + "static/media/bigblob1.1628d668b34e8cbbda1e6ef3cb0f1a2f.svg";
export { ForwardRef as ReactComponent };